import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  EVENTO_SESION_CAIDA,
  borrarSesion,
  guardarDispositivo,
  guardarSesion,
  leerSesion,
  mensajeDeError,
  mozoApi,
} from './mozoApi';

const Contexto = createContext(null);

export const useMozo = () => useContext(Contexto);

export function MozoSesionProvider({ children }) {
  const [sesion, setSesion] = useState(() => leerSesion());
  const [aviso, setAviso] = useState('');

  useEffect(() => {
    const alCaer = (evento) => {
      setSesion(null);
      setAviso(evento.detail || 'La sesión se cerró. Ingresá de nuevo.');
    };

    window.addEventListener(EVENTO_SESION_CAIDA, alCaer);

    return () => window.removeEventListener(EVENTO_SESION_CAIDA, alCaer);
  }, []);

  const entrar = useCallback(async (pin, dispositivo) => {
    try {
      const { data } = await mozoApi.post('/login', { pin, dispositivo });
      const nueva = {
        token: data.token,
        usuario: data.usuario,
        vence_at: data.vence_at,
      };

      guardarDispositivo(dispositivo || '');
      guardarSesion(nueva);
      setSesion(nueva);
      setAviso('');

      return { ok: true };
    } catch (err) {
      return { ok: false, error: mensajeDeError(err, 'No se pudo iniciar sesión.') };
    }
  }, []);

  const salir = useCallback(async () => {
    try {
      await mozoApi.post('/logout');
    } catch (err) {
      // aunque falle la red, se cierra la sesión en este celular
    }

    borrarSesion();
    setSesion(null);
    setAviso('');
  }, []);

  const valor = useMemo(
    () => ({ sesion, usuario: sesion?.usuario || null, aviso, entrar, salir }),
    [sesion, aviso, entrar, salir]
  );

  return <Contexto.Provider value={valor}>{children}</Contexto.Provider>;
}
